import { HTTP_NEWPOST_FETCHING, HTTP_NEWPOST_SUCCESS, HTTP_NEWPOST_FAILED } from '../constants';

const initialState = {
  result: null,
  isFatching: false,
  isError: false
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case HTTP_NEWPOST_FETCHING:
      return { ...state, result: [], isFetching: true, isError: false };
    case HTTP_NEWPOST_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    case HTTP_NEWPOST_FAILED:
      return { ...state, result: [], isFetching: false, isError: true };

    default:
      return state;
  }
};
